import { Typography } from '@mui/material';
import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: 8px 12px 4px 12px;
`;

export const HeaderLabel = styled(Typography)`
  flex: 1;
`;

export const HeaderShortcut = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2.5)};
  padding: 0 6px 8px 6px;
`;
